module.exports = __webpack_public_path__ + "static/interactiveContentNo-e9a0c12e4664ec45e18e663bd7bb671f.png";